module.exports = __webpack_public_path__ + "static/media/about_02.cf6f8baf.svg";